import React from "react";
import "./linehorizontal.css";
//import { } from 'react-bootstrap';

 class LineHorizontal extends React.Component {
  render() {
    return (
      <div className="line-horizontal">
      </div>
    );
  }
}

export default LineHorizontal;


// WEBPACK FOOTER //
// ./src/ui/components/LineHorizontal.js